module.exports = __webpack_public_path__ + "img/gm_icon.41af8798.png";